import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import InputComponent from '../../components/InputComponent';
import { useAuth } from '../../contexts/AuthContext';

const ClientInfo = () => {
	const { register, setValue, getValues } = useFormContext();
	const { user } = useAuth();

	// Fyll bestillerfelter fra innlogget bruker kun når de er tomme (utkast kan ha egne verdier).
	useEffect(() => {
		if (!user) {
			return;
		}
		const name =
			user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
		if (!String(getValues('ordererName') || '').trim()) {
			setValue('ordererName', name);
		}
		if (!String(getValues('ordererEmail') || '').trim()) {
			setValue('ordererEmail', user.email || '');
		}
		if (!String(getValues('ordererPhone') || '').trim()) {
			setValue('ordererPhone', user.telephone || '');
		}
	}, [user, setValue, getValues]);

	return (
		<div className='clientInfo flex flex-row'>
			<div>
				<InputComponent
					label='Firmanavn kunde'
					type='text'
					name='companyName'
					required
					register={register}
					autoComplete='organization'
				/>
			</div>
			<div>
				<InputComponent
					label='Navn på bestiller ADA'
					type='text'
					name='ordererName'
					required
					register={register}
					readOnly
				/>
			</div>
			<div>
				<InputComponent
					label='Epost til bestiller ADA'
					type='email'
					name='ordererEmail'
					required
					register={register}
					readOnly
				/>
			</div>
			<div>
				<InputComponent
					label='Telefon'
					type='tel'
					name='ordererPhone'
					register={register}
				/>
			</div>
		</div>
	);
};

export default ClientInfo;
